import {createContext, useContext} from 'react';

/*
 * Types.
 */

export interface ModalContextValue {
  getLabelProps: () => ModalLabelProps | {};
}

export interface ModalLabelProps {
  id: string;
}

/*
 * Context.
 */

export const ModalContext = createContext<ModalContextValue>({
  getLabelProps: () => ({}),
});

/*
 * Hook.
 */

export function useModalContext() {
  return useContext(ModalContext);
}
